import {Module} from '@gongxigames/framework/slot/fragments/module/Module';
import {LogicEvents} from '@gongxigames/framework/slot/services/logic/LogicEvents';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow/FlowModuleEvents';
import {GenericPopupEvents} from '@gongxigames/framework/slot/modules/genericPopup/GenericPopupEvents';
import {GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup/GenericPopupType';
import {BuyBonusBalanceView} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusBalance/BuyBonusBalanceView';
import {BuyBonusBalanceViewMobile} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusBalance/BuyBonusBalanceViewMobile';
import {CoinFlightEvents} from '@gongxigames/framework/slot/modules/buyBonus/coinFlight/CoinFlightEvents';
import {isEnabledRubyCoins} from '@gongxigames/framework/slot/modules/buyBonus/isEnabledRubyCoins';
import {ModuleIsEnabledFilter} from '@gongxigames/framework/core';
import {KeypadControlsEvents} from '@gongxigames/framework/slot/modules/keypadControls/KeypadControlsEvents';

export class BuyBonusBalanceModule extends Module<BuyBonusBalanceView> {
    public static readonly NAME: symbol = Symbol('BuyBonusBalanceModule');
    public static readonly isEnabled: ModuleIsEnabledFilter = isEnabledRubyCoins;

    protected setupViews(): void {
        if (this.isPlatformDesktop()) {
            this.setView(BuyBonusBalanceView.NAME);
        } else {
            this.setView(BuyBonusBalanceViewMobile.NAME);
        }
    }

    protected setupStates(): void {
    }

    protected setupEvents(): void {
        super.setupEvents();

        this.on(KeypadControlsEvents.TOTAL_BET_CHANGED, this.onBetChanged);
        this.on(CoinFlightEvents.COIN_FLIGHT_FINISHED, this.onCoinFlightFinished);
        this.on(LogicEvents.BUY_RESPONSE, this.onBuyResponseReceived);
        this.on(GenericPopupEvents.INTRO_STARTED, this.onFreeSpinsStarted);
        this.on(FlowModuleEvents.FREESPINS_RESTORED, this.onFreeSpinsStarted);
        this.on(FlowModuleEvents.ENTER_BASIC_STATE, this.onFeatureFinished);
        this.on('General.UI.BALANCE.UPDATED', this.onBalanceUpdated);
    }

    protected onBalanceUpdated(): void {
        this.checkForUkRegulation();
    }

    protected onCoinFlightFinished(eventID: symbol, balance: number): void {
        this.view.prepareAnimation();
        this.view.updateRubyValues(balance);
        this.checkForUkRegulation();
    }

    protected onBuyResponseReceived(): void {
        this.updateBuyBonusData();
    }

    protected onBetChanged(): void {
        this.updateBuyBonusData();
        this.checkForUkRegulation();
    }

    protected updateBuyBonusData(): void {
        this.view.updateRubyValues(this.logic.getRubyBalance());
    }

    protected onFreeSpinsStarted(id: symbol, type: symbol): void {
        if (type === GenericPopupType.FREESPIN_INTRO) {
            this.view.setDisabledBalanceState();
        }
    }

    protected onFeatureFinished(): void {
        this.checkForUkRegulation();
    }

    protected checkForUkRegulation(): void {
        if (this.settings.get('ukRegulations')) {
            if (this.logic.isBonusCanBeBought()) {
                this.view.setEnabledBalanceState();
            } else {
                this.view.setDisabledBalanceState();
            }
        } else {
            this.view.setEnabledBalanceState();
        }
    }
}
